exports.default = {
  'invite_title': 'Invite friends and earn credits',
  'invite_subtitle': 'You and your friend will both earn {points} credits.',
  'share_web': 'Share on web',
  'share_mobile': 'Share on mobile',
  'invite_code_label': 'Invite Code',
  'copy_link': 'Copy invite link',
  'invite_facebook': 'Invite Facebook friends',
  'invitations': 'Invitations',
  'credits': 'Credits',
  'referrals': 'Referrals',
  'history_title': 'Invitation history',
  'anonymous_user': 'Anonymous user',
  'status_pending': 'Pending',
  'status_issued': 'Issued',
  'status_failed': 'Failed',
  'status_limit': 'Invitation limit',
  'status_error': 'Error',
  'bind_title': 'Enter Invite Code',
  'bind_subtitle': 'Enter the invitation code to receive reward points.',
  'bind_placeholder': 'Please enter invite code',
  'bind_btn': 'Bind Invite Code',
  'bind_code_required': 'Invite code cannot be empty',
  'bind_success': 'Invite code bound successfully!',
  'bind_failed': 'Failed to bind invite code, please try again',
  'bind_already_bound': 'You have already bound an invite code',
  'bind_already_bound_user': 'You have already bound a user invite code',
  'bind_already_bound_channel': 'You have bound the channel code',
  'no_records': 'No records yet',
  'history_load_failed': 'Could not load invitation history. Please try again.',
  'history_retry': 'Retry',
  'share_text': 'PAITEAMS invites you to register and earn points! Come and join us now!'
}
